module.exports = __webpack_public_path__ + "img/text-mark11.a1213747.png";